// @ts-nocheck
import { inject } from '@angular/core';
import { ASSETS } from '../../../assets/assets';
import { replaceAllNotHexadecimalTextCursor } from '../replaceWithCursorPosition';

export class MaskProtocolCGov {
  public insertIconValidate = true;
  public validateAllDigit = false;

  public maxLength = 17;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotHexadecimalTextCursor(
      value,
      cursorPosition
    );

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(
    value: string | null,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } | null {
    if (!value) return null;
    const valueLimitedChars = value?.slice(0, this.maxLength)?.replace(/\D | \. | \//g, '');

    try {
      const cases = {
        case0: /^(\d{4})\.?(\d{1,2})$/,
        case1: /^(\d{4})\.?(\d{2})\/?(\d{1,11})$/,
      };

      if (valueLimitedChars.match(cases.case0)) {
        const formatedValue = valueLimitedChars.replace(cases.case0, '$1.$2');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (valueLimitedChars.match(cases.case1)) {
        const formatedValue = valueLimitedChars.replace(cases.case1, '$1.$2/$3');

        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 2 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else {
        return { formatedValue: valueLimitedChars, formatedCursorPosition: cursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: valueLimitedChars, formatedCursorPosition: cursorPosition };
    }
  }
  public validate(value) {
    return value.match(/^(\d){4}\.(\d){2}\/(\d){11}$/);
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['protocolCGov']];
  }
}

export class InjectableMaskProtocolCGov extends MaskProtocolCGov {
  constructor(public assets = inject(ASSETS)) {
    super(null, assets);
  }
}
